import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface ClioStatus {
  connected: boolean;
  email: string;
  display_name: string;
}

export const clioApiClient = createApi({
  reducerPath: 'clioApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['ClioStatus'],
  endpoints: (builder) => ({
    getClioStatus: builder.query<ClioStatus, { firmId: string }>({
      query: ({ firmId }) =>
        `api/integrations/clio/status?firm_id=${firmId}`,
      providesTags: (_result, _error, { firmId }) => [
        { type: 'ClioStatus', id: firmId },
      ],
    }),
    disconnectClio: builder.mutation<{ message: string }, { firmId: string }>(
      {
        query: ({ firmId }) => ({
          url: `api/integrations/clio/disconnect?firm_id=${firmId}`,
          method: 'POST',
        }),
        invalidatesTags: (_result, _error, { firmId }) => [
          { type: 'ClioStatus', id: firmId },
        ],
      },
    ),
  }),
});

export const {
  useGetClioStatusQuery,
  useDisconnectClioMutation,
} = clioApiClient;
